import { selectorCountryName } from "../../../shared/selectors/selectorCountryName";
import { DataView } from "../../../shared/components/DataView";
import { FormDataAccountType } from "./FormAccountType";

type Props = {
  formData?: FormDataAccountType;
  onEdit?: () => void;
};

export const ReviewAccountType: React.FC<Props> = props => {
  const data: Partial<FormDataAccountType> = props.formData ?? {};

  return (
    <DataView
      title="Account type"
      onEdit={props.onEdit}
      data={[
        {
          label:
            data.type === "Business"
              ? "Country of Incorporation"
              : "Country of Tax Residence",
          value: data.country ? selectorCountryName(data.country) : undefined
        },
        {
          label: "Account type",
          value: data.type
        }
      ]}
    />
  );
};
